import { useDispatch, useSelector } from "react-redux";

import { toggleWelcomeModal, toggleGetStartedPanel } from "Layout/slice";

import { IconRocket } from "assets/icons";
import { IconHandWave } from "assets/icons";
import { setItemInStorage } from "utils/storage";
import { Button } from "components/Button/index";
import { WELCOME_MODAL_KEY } from "utils/constants";
import { Title } from "style/components/Title.styles";
import { WelcomeModalContainer } from "./WelcomeModal.styles";
import { showWelcomeModalSelect } from "Layout/slice/selector";

const WelcomeModal = () => {
  const show = useSelector(showWelcomeModalSelect);
  const dispatch = useDispatch();

  const onHide = () => {
    setItemInStorage(WELCOME_MODAL_KEY, true);
    dispatch(toggleWelcomeModal(false));
  };

  const handleGetStarted = () => {
    onHide();

    dispatch(toggleGetStartedPanel(true));
    setTimeout(() => {
      dispatch(toggleGetStartedPanel(true));
    }, 1000);
  };

  return (
    <WelcomeModalContainer show={show} onHide={onHide}>
      <IconRocket />
      <Title>
        Welcome! <IconHandWave className="mb-0 mx-1" />
      </Title>
      <p>{`We'll get you started with data-driven automated investing with just a few quick steps`}</p>
      <Button onClick={handleGetStarted}>Get Started</Button>
    </WelcomeModalContainer>
  );
};

export { WelcomeModal };
